import styled from '@emotion/styled'
import { size } from '@styles/theme'
import { ButtonBase } from '@mui/material'

const TopButton = styled(ButtonBase)`
  // border: ${props => props?.isActive ? 'none' : '1px solid rgba(255,255,255,0.5)'};
  // background-color: ${props => props?.isActive ? 'white' : 'transparent'};
  // color: ${props => props?.isActive ? 'black' : 'white'};
  background-color: #333333;
  color: white;
  border-radius: 100px;
  font-size: 1rem;
  padding: ${size(0.75)} ${size(1.85)};
  font-weight: 500;
  height: 32px;
`

export { TopButton }
